import { http } from 'vue'

export default {
  // load plans from the API server
  loadPlans (context, params = {}) {
    return http.get('plans?company_id=' + params.companyId)
  },
  // create plan at the API server
  postCompanyPlan (context, params = {}) {
    return http.post('company_plans', params.data)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/plans/actions.js